import { PopupModal } from 'components/modals/ModalBox'
import useButtonLoader from 'hooks/useButtonLoader';
import React from 'react'
import { deleteOfferApi } from 'services/offer';
import { toastMessage } from 'utils/toastMessage';

const DeleteOffer = ({ modal, close, selectedData = {}, setState = () => { } }) => {
    const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");

    const deleteBannerHandler = async () => {
        try {
            setButtonLoader(true);
            const {
                data: { code, status, message },
            } = await deleteOfferApi(selectedData._id);
            if (status || code === 200) {
                setState((prevList) =>
                    prevList.filter(
                        (bannerProp) => bannerProp._id !== selectedData._id
                    )
                );
                close();
                toastMessage(message, "success", "DeleteOffer");
            }
        } catch (e) {
            console.log("error:", e.error);
        } finally {
            setButtonLoader(false);
        }
    };
    return (
        <PopupModal
            show={modal}
            handleClose={close}
            content="Are you sure you want to Delete this Offer?"
            title="Delete Banner"
            buttonLoader={buttonLoader}
            action={deleteBannerHandler}
        />
    )
}

export default DeleteOffer